import { c as _c } from "react/compiler-runtime";
import { splitFilePath } from '@/lib/file-paths/split-file-path';
import { cn } from '@/lib/utils';
type PrV2FilePathLabelProps = {
  filename: string;
  title?: string;
  className?: string;
  basenameClassName?: string;
  directoryClassName?: string;
};
export function PrV2FilePathLabel(t0) {
  const $ = _c(21);
  const {
    filename,
    title: t1,
    className,
    basenameClassName,
    directoryClassName
  } = t0;
  const title = t1 === undefined ? filename : t1;
  let t2;
  if ($[0] !== filename) {
    t2 = splitFilePath(filename);
    $[0] = filename;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    basename,
    directory
  } = t2;
  let t3;
  if ($[2] !== className) {
    t3 = cn("flex min-w-0 flex-1 items-baseline gap-2 text-left", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== directory || $[5] !== filename) {
    t4 = directory ? <span aria-hidden="true" className="sr-only" data-testid="pr-v2-file-path-search-text">{filename}</span> : null;
    $[4] = directory;
    $[5] = filename;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== basenameClassName) {
    t5 = cn("max-w-full shrink-0 truncate text-sm text-zinc-200", basenameClassName);
    $[7] = basenameClassName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== basename || $[10] !== t5) {
    t6 = <span className={t5}>{basename}</span>;
    $[9] = basename;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== directory || $[13] !== directoryClassName) {
    t7 = directory ? <span className={cn("min-w-0 truncate text-sm text-zinc-500", directoryClassName)}>{directory}</span> : null;
    $[12] = directory;
    $[13] = directoryClassName;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t6 || $[18] !== t7 || $[19] !== title) {
    t8 = <span className={t3} title={title}>{t4}{t6}{t7}</span>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
    $[19] = title;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}